import type { ImportSupportedExtension } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';

import type { ImportTypeConfig } from '../config';
import { useImportBlobDownload } from './use-import-blob-download';

// ─── Hook ─────────────────────────────────────────────────────────────────────

/** Downloads the generated template (CSV or XLSX) for the given import type. */
export function useDownloadTemplate(
  config: ImportTypeConfig,
): UseMutationResult<void, Error, ImportSupportedExtension> {
  return useImportBlobDownload<ImportSupportedExtension>((api, format) => {
    if (!config.templateEndpoint) {
      throw new Error(`No template endpoint configured for import type '${config.type}'`);
    }
    return api.downloadTemplate(config.templateEndpoint, format);
  }, 'importData.template.downloadError');
}
